// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29UZM","field":"styles_field__1I0jQ","fieldCol":"styles_fieldCol__DSWRW","diffCol":"styles_diffCol__2s2XK","diff":"styles_diff__R03mo"};